import { Button } from '@material-ui/core';
import React, { FC, memo, MouseEventHandler, useCallback } from 'react';
import styled from 'styled-components';
import { WhiteButton } from './mui-white-button';

interface Props {
  label: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  variant?: 'text' | 'outlined' | 'contained';
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
  disableFocusRipple?: boolean;
  color?: 'inherit' | 'primary' | 'secondary' | 'default' | 'white';
}

const ButtonText = styled.div`
  white-space: nowrap;
`;

export const MuiButton: FC<Props> = memo(
  ({
    label,
    onClick: onClickInput,
    variant = 'contained',
    size,
    disabled,
    color = 'primary',
    disableFocusRipple
  }: Readonly<Props>) => {
    const onClick = useCallback(
      (_ev: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (onClickInput !== undefined) {
          onClickInput(_ev);
        }
      },
      [onClickInput]
    );

    return color === 'white' ? (
      <WhiteButton
        onClick={onClick}
        variant={variant}
        size={size}
        disabled={disabled}
        disableFocusRipple={disableFocusRipple}
      >
        {label}
      </WhiteButton>
    ) : (
      <Button
        onClick={onClick}
        variant={variant}
        size={size}
        disabled={disabled}
        disableFocusRipple={disableFocusRipple}
        color={color}
      >
        <ButtonText>{label}</ButtonText>
      </Button>
    );
  }
);

MuiButton.displayName = 'MuiButton';
